define('modules/lists/models/follow.list.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var FollowingListModel = BaseModel.extend({
        base: 'list/following/requests',
        mode: 'follow',
        url:function(){
            if(this.mode == 'follow'){
                return window.utils.makeUrl('prospector/v1/' + this.base);
            } else {
                var url = 'prospector/v1/' + this.base + "?";
                if(this.has('listId') && this.get('listId') != 0){
                    url += "listId=" + this.get('listId');
                } else {
                    url += "identityId=" + this.get('identityId');
                }
                return window.utils.makeUrl(url + "&alertType=" + this.get('alertType'));
            }
        }
    });
    return FollowingListModel;
});

